document.addEventListener('DOMContentLoaded', () => {

    const collectionPage = document.querySelector('.page-template-template-collections')
    const collectionDetailPage = document.querySelector('.tax-pa_collection')
    const projectsPage = document.querySelector('.post-type-archive-project')
    const searchPage = document.querySelector('.search-results')
    const checkboxes = document.querySelectorAll('.c-filter-list input[type="checkbox"]');
    const applyBtn = document.querySelector('.c-mobile-filter-screen__apply-btn');

    if (collectionPage !== null || collectionDetailPage !== null || projectsPage !== null || searchPage !== null) {

        document.querySelectorAll('.js-filter-list-btn').forEach(function (btn) {
            btn.addEventListener('click', function () {

                const targetId = this.getAttribute('data-id')
                const filterSelector = '.c-filter-list[data-id=' + targetId + ']'

                toggleFilterListClasses(filterSelector)
            })
        });

        document.querySelectorAll('.js-filter-list-btn--mobile').forEach(function (btn) {
            btn.addEventListener('click', function () {

                const targetId = this.getAttribute('data-id')
                const filterSelector = '.c-filter-list--mobile[data-id=' + targetId + ']'

                toggleFilterListClasses(filterSelector)

            })
        });

        function toggleFilterListClasses(filterSelector) {

            const filterList = document.querySelector(filterSelector)
            const children = document.querySelector(filterSelector + ' .c-filter-list__content__items')
            const childrenHeight = children.getBoundingClientRect().height

            if (filterList.classList.contains('is-open')) {
                filterList.classList.remove('is-open')
                document.querySelector(filterSelector + ' .c-filter-list__content').style.maxHeight = null;
                return
            }

            if (!filterList.classList.contains('is-open')) {
                filterList.classList.add('is-open')
                document.querySelector(filterSelector + ' .c-filter-list__content').style.maxHeight = childrenHeight + 'px';
                return
            }
        }

        function toggleApplyButton() {
            const anyChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
            if (anyChecked) {
                applyBtn.classList.remove('hidden');
            } else {
                applyBtn.classList.add('hidden');
            }
        }

        toggleApplyButton();

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', toggleApplyButton);
        });

    }
})